import {Injectable, NgModule} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpParams} from "@angular/common/http";
import {catchError, concatMap, map, Observable, of} from "rxjs";
import { iResult } from "../entity/interfaces/allgemein";
import {MatSnackBar} from "@angular/material/snack-bar";

import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  constructor(private http: HttpClient,private snackBar: MatSnackBar,private router: Router) { }

  /** get an SYMFONY Backend
* @param parameter: getParameter
* @param adressEnd: Endpunkt
* @return Observable iResult
* */
  public get(adressEnd: string, parameter?:object): Observable<iResult>
  {
    let params = parameter?this.parameterToHttpParams(parameter):undefined;
    return this.http.get<any>(adressEnd, { params: params })
      .pipe(map(resp => {
        if (resp.success) {
          return resp;
        } else {
          this.snackBar.open(resp.nachricht, '', {
            duration: 5000,
          });
          return resp;
        }
      }));
  }
  parameterToHttpParams(parameter: any): HttpParams {
    let httpParamter = new HttpParams();
    for (let key in parameter) {
      httpParamter = httpParamter.append(key, parameter[key]);
    }
    return httpParamter;
  }


  /**
   * POST an SYMFONY Backend
   * @param body: Postbody
   * @param adressEnd: Endpunkt
   * @return Observable Result
   * */
  post(body: object | string, adressEnd: string): Observable<iResult> {
    return this.http.post<any>
    (adressEnd, body).pipe(catchError(this.handleError),concatMap(resp => {
      if(resp == 'redo') {
        return this.post(body, adressEnd)
      }
      const result = resp as iResult;
      if (result) {
       if(result.nachricht) {
         this.snackBar.open(result.nachricht, '', {
           duration: 5000,
         });

        }
        return of(result);
      } else {
        return of({success: false, nachricht: 'Allgemeiner Serverfehler',content:''} as iResult)
      }
    }));
  }

  private handleError = (error: HttpErrorResponse)=> {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    }  else if(error.status === 403) {
      let result: iResult = {
        success : false,
        nachricht : 'Fehlende Berechtigung',
        content : null
      };
      return of(result)
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return of(error.error)
  }
}
